import { Badge } from '@rentflowdev/ui'
import type { BuildJobStatus } from '@rentflowdev/api'

const STATUS_VARIANTS: Record<BuildJobStatus, 'muted' | 'info' | 'success' | 'destructive'> = {
	QUEUED:     'muted',
	BUILDING:   'info',
	SIGNING:    'info',
	PUBLISHING: 'info',
	DONE:       'success',
	FAILED:     'destructive',
}

export const BUILD_JOB_STATUS_LABELS: Record<BuildJobStatus, string> = {
	QUEUED:     'В очереди',
	BUILDING:   'Сборка',
	SIGNING:    'Подпись',
	PUBLISHING: 'Публикация',
	DONE:       'Готово',
	FAILED:     'Ошибка',
}

interface BuildJobStatusBadgeProps {
	status: BuildJobStatus
}

export function BuildJobStatusBadge({ status }: BuildJobStatusBadgeProps) {
	return <Badge variant={STATUS_VARIANTS[status]}>{BUILD_JOB_STATUS_LABELS[status]}</Badge>
}
